export default "__VITE_ASSET__Clr977l0__"